import { useState } from "react";

import BalancePage from "./BalancePage";
import ImportsPage from "./ImportsPage";
import GeoDistributionPage from "./GeoDistributionPage";
import TraceabilityDashboardPage from "./TraceabilityDashboardPage";
import { fa } from "../i18n/fa";

export default function TraceabilityInspectorPage() {
  const [tab, setTab] = useState("dashboard");

  return (
    <div className="tr-inspector-panel" dir="rtl">
      <nav className="tr-top-tabs" aria-label={fa.inspectorTabs.label}>
        <button
          type="button"
          className={tab === "dashboard" ? "on" : ""}
          aria-current={tab === "dashboard" ? "page" : undefined}
          onClick={() => setTab("dashboard")}
        >
          {fa.inspectorTabs.dashboard}
        </button>
        <button
          type="button"
          className={tab === "imports" ? "on" : ""}
          aria-current={tab === "imports" ? "page" : undefined}
          onClick={() => setTab("imports")}
        >
          {fa.inspectorTabs.imports}
        </button>
        <button
          type="button"
          className={tab === "balance" ? "on" : ""}
          aria-current={tab === "balance" ? "page" : undefined}
          onClick={() => setTab("balance")}
        >
          {fa.inspectorTabs.balance}
        </button>
        <button
          type="button"
          className={tab === "geo" ? "on" : ""}
          aria-current={tab === "geo" ? "page" : undefined}
          onClick={() => setTab("geo")}
        >
          {fa.inspectorTabs.geo}
        </button>
      </nav>
      {tab === "dashboard" && <TraceabilityDashboardPage />}
      {tab === "imports" && <ImportsPage />}
      {tab === "balance" && <BalancePage />}
      {tab === "geo" && <GeoDistributionPage />}
    </div>
  );
}
